module.exports = __webpack_public_path__ + "assets/manage1.f601e628.svg";